import { createMemoStyles } from '@wds/utils';
var useStyles = createMemoStyles(function (_ref) {
  var palette = _ref.palette,
    spacing = _ref.spacing,
    elevation = _ref.elevation,
    type = _ref.type,
    border = _ref.border;
  return {
    fullHeight: {
      height: '100%'
    },
    footerAnon: {
      position: 'relative',
      zIndex: elevation.sky,
      backgroundColor: palette.background.light,
      padding: [spacing[7], 0],
      color: palette.text.dark,
      fontSize: type.fontSize.bodySm,
      borderTop: border.main
    },
    footerAuth: {
      position: 'relative',
      zIndex: elevation.sky,
      backgroundColor: palette.background.light,
      padding: [spacing[7], 0],
      color: palette.text.dark,
      fontSize: type.fontSize.bodySm
    },
    footerBorder: {
      borderBottom: border.main
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map